/* Copyright (c) 2025 Xperi. All Rights Reserved. */

import { Channel } from '../../../../core/entities';
import { RecordingRestriction } from '../../../../core/usecases';
import { RestrictionMessage } from '../../../common';
import {
    getReasonWhyChannelIsFilteredOut,
    isChannelPartOfFilteredOutChannels,
} from '../filteredguide.utils';

type FilteredGuidePreviewProps = {
    selectedChannel: Channel;
};

const FilteredGuidePreviewChannel = ({ selectedChannel }: FilteredGuidePreviewProps) => {
    const isChannelFilteredOut = isChannelPartOfFilteredOutChannels(selectedChannel);
    return (
        <>
            <div className="content-airing-info channel-preview-top">
                <span>{selectedChannel.callSign}</span>
                <span>{selectedChannel.channelNumber}</span>
                <div
                    className={`preview-stream-type-icon ${selectedChannel.videoResolution}`}
                ></div>
            </div>
            <div className="content-airing-info channel-preview-bottom">{selectedChannel.name}</div>
            <RestrictionMessage
                displayType={RecordingRestriction.PREVIEW_AREA}
                channel={selectedChannel}
            />
            {isChannelFilteredOut && (
                <div className="content-airing-info channel-filtered-out">
                    <span>{getReasonWhyChannelIsFilteredOut(selectedChannel)}</span>
                </div>
            )}
        </>
    );
};

export default FilteredGuidePreviewChannel;
